// extracted by mini-css-extract-plugin
module.exports = {"button":"QuantitySpinner_button__XjIlY","disabled":"QuantitySpinner_disabled__3AEEd"};